import { Controller } from "@hotwired/stimulus"

// Trim Trix toolbar: hide file tools (unless broadcast) and heading1.
export default class extends Controller {
  connect() {
    this.onInitialize = this.customizeToolbar.bind(this)
    this.element.addEventListener("trix-initialize", this.onInitialize)
    if (this.element.editor) this.customizeToolbar()
  }

  disconnect() {
    this.element.removeEventListener("trix-initialize", this.onInitialize)
  }

  customizeToolbar() {
    const toolbar = this.element.toolbarElement
    if (!toolbar) return

    toolbar.querySelectorAll(".trix-button-group").forEach((group) => {
      const groupType = group.getAttribute("data-trix-button-group")
      if (groupType === "file-tools" && this.element.dataset.broadcastForm !== "true") {
        group.remove()
      }
      if (groupType === "block-tools") {
        group.querySelector('[data-trix-attribute="heading1"]')?.remove()
      }
    })
  }
}
